import type { PropsWithChildren } from "react";

interface FieldContainerProps {
  dataTestId?: string;
}

export const FieldContainer = ({
  children,
  dataTestId,
}: PropsWithChildren<FieldContainerProps>) => (
  <div
    className="border-dark flex flex-col gap-y-3 rounded-lg border p-3"
    data-testid={dataTestId || undefined}
  >
    {children}
  </div>
);
